import Modal from "react-bootstrap/Modal";
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const ChargesHistory = (props) => {
    const {show, handleCancel, data} = props;
    const userDetails = useSelector((state) => state.auth.user);

    return (
        <Modal
            {...props}
            size="lg"
            className="topUpModal productskuListing carrier-reconciliation-modal"
            backdrop="static"
            show={show}
            onHide={handleCancel}
        >
            <div className="top_modal_header_container no_mrg">
                <div>
                    <span>Charges Applied</span>
                </div>
                <div className="modalDeleteWrapper">
                    <button
                        type="button"
                        onClick={() => handleCancel()}
                        className="btn-close"
                        aria-label="Close"
                    ></button>
                </div>
            </div>

            <div className="modal_container_rate_card pb-3 productList">
                {data?.carrierConnectId && (
                    <div className="typeAddress fontFix mt-2">
                        {userDetails?.Value?.isSuperAdmin && (
                            <div>
                                <p>Company Seller : <strong>{data?.companySellerName}</strong></p>
                                <p>Carrier Connect ID : <strong>{data?.carrierConnectId}</strong></p>
                            </div>
                        )}
                        <div>
                            <p>Status : <strong>{data?.statusName}</strong></p>
                            <p>Carrier Name : <strong>{data?.carrierName}</strong></p>
                        </div>
                    </div>
                )}
                {data?.taskId && (
                    <div className=" fontFix mt-2">
                        <div style={{flex: 1}}>
                            <p className="mb-1">Title : <strong>{data?.taskTitle}</strong></p>
                        </div>
                        <div>
                            <p className="mb-1">Type : <strong>{data?.taskTypeName}</strong></p>
                        </div>
                        <div>
                            <p className="mb-1">Priority : <strong>{data?.taskPriorityName}</strong></p>
                        </div>
                    </div>
                )}
                <div className="table-responsive main_content_table_history tableFixHead muiCollapsibleTable noBorder">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Index</th>
                                <th>Applied On</th>
                                <th>Amount</th>
                                <th>Comment</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.postCharges?.map((item, index) => (
                                <tr key={uuidv4()}>
                                    <td width={'10%'}>{index + 1}</td>
                                    <td width={'25%'}>
                                        {moment(item.postChargeDate).format(
                                            "MM-DD-YYYY | h:mm:ss A"
                                        )}
                                    </td>
                                    <td width={'10%'}>{item.postChargeAmount}</td>
                                    <td className="taskComment">{item.postChargeComment}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Modal>
    );
}

ChargesHistory.propTypes = {
    data: PropTypes.object,
    show: PropTypes.bool.isRequired,
    handleCancel: PropTypes.func.isRequired,
};
 
export default ChargesHistory;